import { Flex } from "@chakra-ui/react";
import React from "react";

import { useShadcnInsetChrome } from "@/contexts/ShadcnInsetChromeContext";

import {
  StatisticsEmptyState,
  statisticsPageMinHeight,
} from "../Statistics/components/statisticsEmptyState";

type UniversityCourseLoadingStateProps = {
  /** Shown as “Loading {label}”. Falls back to courseTitle, then “course”. */
  label?: string;
  courseTitle?: string;
  description?: string;
};

export function UniversityCourseLoadingState({
  label,
  courseTitle,
  description,
}: UniversityCourseLoadingStateProps): React.ReactElement {
  const shadcnInset = useShadcnInsetChrome();
  const pageMinHeight = statisticsPageMinHeight(shadcnInset);
  const FlexAny = Flex as any;
  const displayLabel = label?.trim() || courseTitle?.trim() || "course";

  return (
    <FlexAny
      data-university-page=""
      direction="column"
      w="100%"
      minH={pageMinHeight}
      align="center"
      justify="center"
    >
      <StatisticsEmptyState
        variant="loading"
        fillParent
        title={`Loading ${displayLabel}`}
        description={description ?? "Please wait while we load your course."}
      />
    </FlexAny>
  );
}
